<template>
  <div class="management">
    <!-- Filter -->
    <FilterFrame
      ref="filter"
      :filter-form="outputManagementFilterStructure"
      class="filter-frame"
      @search="search"
      @clear="clearSearch()"
    />
    <!-- Table -->
    <el-table
      :data="outputTagList"
      style="width: 100%"
    >
      <el-table-column
        label="#"
        type="index"
        width="50"
      />
      <el-table-column
        v-for="[key, value] of Object.entries(managementStructure) "
        :key="key"
        :prop="key"
        :label="value"
        :width="key === 'Time' ? '110px':'auto'"
      >
        <template slot-scope="scope">
          <!-- 推播開關 -->
          <div
            v-if="key === 'NotificationSwitch'"
            class="switch"
          >
            <!-- el-switch 需傳入 bool 而非 int  -->
            <!-- 正翰表示：目前 1 為關閉，0 為開啟（與直觀相反） -->
            <el-switch
              :value="!scope.row[key]"
              @change="handleSwitchChange(scope.$index)"
            />
          </div>
          <!-- 告警事件累計次數 -->
          <div
            v-else-if="key === 'Events'"
            class="detail"
            :class="{clickable: scope.row[key].length > 0}"
            @click="handleClickTagDetail(scope.row)"
          >
            {{ scope.row[key].length }}
          </div>
          <div
            v-else
            class="regular"
            :class="{highlight: scope.row.Status === '異常' && (key ==='Status' || key === 'Value' || key === 'Level')}"
          >
            {{ scope.row[key] || '-' }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <TableLoading :is-loading="isLoading" />
  </div>
</template>

<script>
import TableLoading from '@/components/TableLoading'
import FilterFrame from '@/components/FilterFrame'
import { managementStructure, managementFilterStructure, TagStatus, TagLevelZh } from '../models'
import { timeFormat, processFilterOptions } from '../utils'
export default {
  components: {
    FilterFrame,
    TableLoading
  },
  props: {
    assetCategoryDataOptions: Array
  },
  data () {
    const maxCount = 10
    const inputTagList = []
    const outputTagList = []
    const defaultReq = {
      LevelList: [1, 2, 3, 4],
      MaxCount: maxCount
    }
    const req = defaultReq
    const isLoading = true
    const isNoMoreList = false
    const outputManagementFilterStructure = managementFilterStructure
    return {
      managementStructure,
      inputTagList,
      outputTagList,
      outputManagementFilterStructure,
      maxCount,
      defaultReq,
      req,
      isLoading,
      isNoMoreList
    }
  },
  watch: {
    inputTagList: function () {
      let tempTagList = [...this.inputTagList]
      // 無 L0
      // TODO: 若後端供選擇則可以移除前端過濾
      tempTagList = tempTagList.filter(el => el.Level !== 0)
      tempTagList = tempTagList.map(el => {
        const tempEl = { ...el }
        tempEl.Status = TagStatus[tempEl.Status + 1]
        tempEl.LatestDetectionTime = timeFormat(tempEl.LatestDetectionTime, true)
        tempEl.Level = TagLevelZh[tempEl.Level]
        return tempEl
      })
      this.outputTagList = tempTagList
    },
    assetCategoryDataOptions (nV, oV) {
      const obj = this.outputManagementFilterStructure.find(el => el.name === 'AssetCategoryId')
      obj.options = nV
      obj.isDisable = false
    }
  },
  async mounted () {
    // 初始化（已移至 BA-alertView 呼叫）
    // 載入更多
    this.$nextTick(() => {
      window.addEventListener('scroll', this.handleScroll)
    })
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    async initTagList () {
      try {
        // 清空列表且呈現 loading 畫面
        this.inputTagList = []
        this.isLoading = true
        const res = await apiBaAlert.getTag(this.req)
        await this.$sleep(1000, res.duration)
        this.inputTagList = res.data
        this.isLoading = false
        this.isNoMoreList = false
      } catch (error) {
        console.log(error)
      }
    },
    async changeSwitch (index) {
      const id = this.outputTagList[index].TagId
      const newNotificationSwitch = !this.outputTagList[index].NotificationSwitch
      try {
        await apiBaAlert.switchNotification(id, {
          // 應傳入 int 而非 bool，故強制轉型
          NotificationSwitch: +newNotificationSwitch
        })
        this.outputTagList[index].NotificationSwitch = newNotificationSwitch
      } catch (error) {
        console.log(error)
      }
    },
    async getMoreTagList () {
      if (this.$route.name === 'baManagement' && !this.isLoading && !this.isNoMoreList && this.outputTagList.length > 0) {
        this.isLoading = true
        const req = {
          ...this.req,
          MaxId: this.outputTagList[this.outputTagList.length - 1].TagId
        }
        try {
          const res = await apiBaAlert.getTag(req)
          // 至少也載個一秒鐘啦～～～
          await this.$sleep(1000, res.duration)
          if (res.data.length < this.maxCount) {
            this.isNoMoreList = true
          }
          this.inputTagList = [
            ...this.inputTagList,
            ...res.data
          ]
          return true
        } catch (error) {
          console.log(error)
          await this.$sleep()
          return false
        } finally {
          this.isLoading = false
        }
      }
    },
    handleScroll (e) {
      this.$handleScroll(this.getMoreTagList)
    },
    handleSwitchChange (index) {
      this.changeSwitch(index)
    },
    search (filterOptions) {
      this.req = processFilterOptions(filterOptions, this.defaultReq)
      this.initTagList()
    },
    clearSearch () {
      this.req = this.defaultReq
      this.initTagList()
    },
    handleClickTagDetail (row) {
      if (row.Events.length > 0) {
        this.$emit('handleClickTagDetail', row)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.management {
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 25px;
  .filter-frame {
    width: 100%;
  }
  .highlight {
    color: $dangerColor;
  }
  .clickable {
    color: $mainColor;
    text-decoration: underline;
    cursor: pointer;
  }
  ::v-deep .el-table {
    @include basicTable(true);
  }
}
</style>
